import { jsx } from "react/jsx-runtime";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import { validateTidalLicense } from "../../base/index.js";
function ReceiptLong(props) {
  return /* @__PURE__ */ jsx(
    ReceiptLongIcon,
    {
      "data-testid": "ReceiptLong",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "ReceiptLong",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
ReceiptLong.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "ReceiptLong"
};
validateTidalLicense();
export {
  ReceiptLong
};
//# sourceMappingURL=ReceiptLong.js.map
